export class TaskCommentDto {
    public comment: string = '';
}
